import { IoClose, IoSearch } from "react-icons/io5";

import classes from './CustomInput.module.scss'

const CustomInput = (props) => {
    return (
        <div className={`${classes.inputContainer} CustomInput_inputContainer_color`}>
            <input
                type={props.type}
                onChange={props.handler}
                onKeyDown={props.onKeyDown}
                placeholder={props.placeholder}
                value={props.value}
                style={{ ...props.inputStyles }} />

            {(props.searchButtonHandler && props.value.trim().length !== 0) && <button className={props.value.trim().length !== 0 ? classes.searchButton : classes.searchButtonDisappear}
                onClick={props.searchButtonHandler}
                aria-label="search">
                <IoSearch size={20} />
            </button>}

            {(props.clearInput && props.value.trim().length !== 0) && <button className={props.value.trim().length !== 0 ? classes.clearButton : classes.clearButtonDisappear}
                onClick={props.clearInput}
                aria-label="clear input">
                <IoClose size={25} />
            </button>}
        </div>
    )
}

export default CustomInput;